<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
        <b-col cols="6" class="mb-2">
          <b-row>
            <b-col cols="6" class="mb-0">
              <label>{{ $t("tenants.file.size_min") }}</label>
              <b-form-input
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="sizeMinFilter"
                class="w-100"
                type="number"
                step=".01"
                :reduce="(val) => val.value"
                @input="(val) => $emit('update:sizeMinFilter', val)"
                append-to-body
                :calculate-position="withPopper"
              />
              
            </b-col>
            <b-col cols="6" class="mb-0">
              <label>{{ $t('tenants.store.type') }}</label>
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="sizeMinType"
                :options="sizeOptions"
                class="w-100"
                :reduce="(val) => val.value"
                @input="(val) => $emit('update:sizeMinType', val)"
                append-to-body
                :calculate-position="withPopper"
              />
            </b-col>
          </b-row>
        </b-col>

      <b-col cols="6" class="mb-2">
        <b-row>
            <b-col cols="6" class="mb-0">
              <label>{{ $t("tenants.file.size_max") }}</label>
              <b-form-input
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="sizeMaxFilter"
                class="w-100"
                type="number"
                step=".01"
                :reduce="(val) => val.value"
                @input="(val) => $emit('update:sizeMaxFilter', val)"
                append-to-body
                :calculate-position="withPopper"
              />
              
            </b-col>
            <b-col cols="6" class="mb-0">
              <label>{{ $t('tenants.store.type') }}</label>
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="sizeMaxType"
                :options="sizeOptions"
                class="w-100"
                :reduce="(val) => val.value"
                @input="(val) => $emit('update:sizeMaxType', val)"
                append-to-body
                :calculate-position="withPopper"
              />
            </b-col>
          </b-row>
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>{{ $t("tenants.file.created_from") }}</label>
          <flat-pickr
            class="form-control"
            :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            :value="createdAtMinFilter"
            @on-change="(selectedDates, val) => {
              $emit('update:createdAtMinFilter', val),
              updateMinDate(val)
            }"
          />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>{{ $t("tenants.file.created_to") }}</label>
          <flat-pickr
            class="form-control"
            :config="maxDateConfig"
            :value="createdAtMaxFilter"
            @on-change="(selectedDates, val) => $emit('update:createdAtMaxFilter', val)"
          />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>{{ $t("tenants.file.extension") }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="extensionFilter"
            :options="extensionOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:extensionFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
      </b-col>

    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper';
import flatPickr from "vue-flatpickr-component";
import { ref, computed } from "@vue/composition-api";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    extensionOptions: {
      type: Array,
      default: null,
    },
    extensionFilter: {
      type: Array,
      default: null,
    },
    sizeMaxFilter: {
      type: String,
      default: null,
    },
    sizeOptions: {
      type: Array,
      default: null,
    },
    sizeMinFilter: {
      type: String,
      default: null,
    },
    createdAtMinFilter: {
      type: String,
      default: null,
    },
    createdAtMaxFilter: {
      type: String,
      default: null,
    },
    sizeMinType: {
      type: String,
      default: null,
    },
    sizeMaxType: {
      type: String,
      default: null,
    },
  },
  setup() {

    const minDate = ref(null);
    const maxDateConfig = computed(() => ({
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      time_24hr: true,
      minuteIncrement: 1,
      minDate: minDate.value ? new Date(minDate.value) : null,
    }));
 
    const updateMinDate = (selectedDates) => {
      if (selectedDates.length) {
          minDate.value = selectedDates
      }
    };

    return {
      maxDateConfig,
      minDate,
      updateMinDate,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
